<template>
<div class="wine-list">
  <div class="wine-list__container">
      <div v-for="(item,index) in items" :key="index" class="wine-list__item" @click="wineClick(item.code)" @mouseenter="mouseEnter(item.code)" @mouseleave="mouseLeave">
        <div class="wine-list__item__image">
            <img :src="item.image" :alt="item.title">
        </div>
        <div class="wine-list__item__title">
          {{ item.title }}
        </div>
        <div class="wine-list__item__subtitle" v-html="item.wine ">
        </div>
      </div>
  </div>
</div>
</template>
<script setup lang="ts">
import type { Emits } from "./model/model";
import type { Props } from './model';

import { usePagesStore } from "@stores/pages";
import {storeToRefs} from "pinia";

defineOptions({
  name:'AppWineList'
})

const emit = defineEmits<Emits>();
const props = defineProps<Props>()
const pagesStore = usePagesStore();


const wineClick = (page:string)=>{
  pagesStore.setPage(page)
}
const mouseEnter = (page:string)=>{
  pagesStore.setHovered(page)
}
const mouseLeave = ()=>{
  pagesStore.setHovered(null)
}
</script>
<style scoped lang="scss">
.wine-list{
  padding: 0 var(--space-60) var(--space-120)  var(--space-60);

  &__container{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    column-gap: var(--space-24);
    grid-row-gap:var(--space-32);
    &:hover > div{
      opacity: 0.6;
    }
    &:hover > div:hover{
      opacity: 1;
    }
  }
  &__item{
    cursor: pointer;
    transition: opacity 0.3s ease-in;
    &__image{
      img{
        object-fit: cover;
        object-position: center;
        max-width: 100%;
        height: 27rem;
      }
      margin-bottom: var(--space-16);
    }
    &__title{
      font-family: var(--ff-secondary);
      font-size: var(--font-size-43);
      line-height: var(--font-size-43);
      color: var(--color-secondary);
      text-align: center;
      margin-bottom: var(--space-16);
    }
    &__subtitle{
      text-align: center;
      white-space: pre-line;
    }
  }
}
</style>